<template>
  <div :style="parentStyle" @click="click">
     <!-- The video -->
    <CanvasVideo ref="vid" v-if="isIOS" height="800" width="800" :style="style" :src="src" :loop="true">
    </CanvasVideo>
    <video ref="vid" v-else height="800" width="800" :style="style" :src="src" :poster="poster" loop>
    </video>
    <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue'
import CanvasVideo from 'vue-canvasvideo'
Vue.use(CanvasVideo)

export default {
  name: 'Video',
  props: ['src','viewmode', 'autoplay','poster'],
  data () {
    var userAgent = window.navigator.userAgent
    var sizeMax = Math.max(window.innerWidth, window.innerHeight)
    var sizeMin = Math.min(window.innerWidth, window.innerHeight)
    if (this.viewmode == '4x3') {
      var style = 'position:relative;top:-' + sizeMin*0.15 + 'px;left:0;height:' + sizeMin*0.9 + 'px;width:' + sizeMin*0.9 + 'px;'
      var parentStyle = 'overflow:hidden;width:' + sizeMin*0.9 + 'px;height:' + sizeMin*0.68 + 'px;'
    } else if (this.viewmode == '5x3') {
      var style = 'position:relative;top:-' + sizeMin*0.20 + 'px;left:0;height:' + sizeMin*0.9 + 'px;width:' + sizeMin*0.9 + 'px;'
      var parentStyle = 'overflow:hidden;width:' + sizeMin*0.9 + 'px;height:' + sizeMin*0.54 + 'px;'
    } else {
      var style = 'position:fixed;max-width:300%;max-height:300%;top:50%;left:50%;margin-top:-'
        + sizeMax/2 + 'px;margin-left:-' + sizeMax/2 + 'px;height:' + sizeMax + 'px;width:' + sizeMax + 'px;'
      var parentStyle = ''
    }
    return {
      isIOS: (window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i)),
      size: sizeMax,
      style,
      parentStyle,
      interval: undefined
    }
  },
  methods: {
    play() {
      this.$refs.vid.play()
      if (this.isIOS) {
        this.interval = setInterval(this.iOSLoop, 2200)
      }
    },
    pause() {
      this.$refs.vid.pause()
      if (this.isIOS) {
        clearInterval(this.interval)
      }
    },
    stop() {
      if (this.isIOS) {
        clearInterval(this.interval)
        this.$refs.vid.setTime(0)
        this.$refs.vid.pause()
      } else {
        this.$refs.vid.currentTime = 0
        this.$refs.vid.pause()
      }
    },
    iOSLoop () {
      this.$refs.vid.setTime(0)
    },
    click() {
      this.$emit('click')
    }
  }
}
</script>

<style>
.video-video {
  display: none;
}
.video-canvas {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  min-height: 100%;
  min-width: 100%;
}
.rangeSlider,.rangeSlider__fill{display:block;-webkit-box-shadow:inset 0 1px 3px rgba(0,0,0,0.3);box-shadow:inset 0 1px 3px rgba(0,0,0,0.3);border-radius:10px}.rangeSlider{position:relative;background:#7f8c8d}.rangeSlider__horizontal{height:20px;width:100%}.rangeSlider__vertical{height:100%;width:20px}.rangeSlider--disabled{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);opacity:.4}.rangeSlider__fill{background:#16a085;position:absolute;z-index:2}.rangeSlider__fill__horizontal{height:100%;top:0;left:0}.rangeSlider__fill__vertical{width:100%;bottom:0;left:0}.rangeSlider__handle{background:#fff;border:1px solid #ccc;cursor:pointer;display:inline-block;width:40px;height:40px;position:absolute;z-index:3;background-image:-webkit-gradient(linear, left top, left bottom, from(rgba(255,255,255,0)), to(rgba(0,0,0,0.1)));background-image:-o-linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.1));background-image:linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.1));-webkit-box-shadow:0 0 8px rgba(0,0,0,0.3);box-shadow:0 0 8px rgba(0,0,0,0.3);border-radius:50%}.rangeSlider__handle__horizontal{top:-10px}.rangeSlider__handle__vertical{left:-10px;bottom:0}.rangeSlider__handle:after{content:"";display:block;width:18px;height:18px;margin:auto;position:absolute;top:0;right:0;bottom:0;left:0;background-image:-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,0.13)), to(rgba(255,255,255,0)));background-image:-o-linear-gradient(rgba(0,0,0,0.13), rgba(255,255,255,0));background-image:linear-gradient(rgba(0,0,0,0.13), rgba(255,255,255,0));border-radius:50%}.rangeSlider__handle:active{background-image:-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,0.1)), to(rgba(0,0,0,0.12)));background-image:-o-linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.12));background-image:linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.12))}input[type=range]:focus+.rangeSlider .rangeSlider__handle{-webkit-box-shadow:0 0 8px rgba(142,68,173,0.9);box-shadow:0 0 8px rgba(142,68,173,0.9)}.rangeSlider__buffer{z-index:1;position:absolute;top:3px;height:14px;background:#2c3e50;border-radius:10px}.vue-canvasvideo-controls{position:absolute;bottom:0;width:100%;background:rgba(0,0,0,0.2);opacity:0;transition:opacity .2s linear}.vue-canvasvideo-controls__wrap{display:flex;align-items:center;margin:0 15px}.vue-canvasvideo-control__button{fill:rgba(255,255,255,0.5);height:30px;cursor:pointer}.vue-canvasvideo-controls__scrubber{margin:0 25px;width:100%}.vue-canvasvideo-controls__scrubber .rangeSlider{height:10px}.vue-canvasvideo-controls__scrubber .rangeSlider__handle{top:-7px;width:22px;height:22px}.vue-canvasvideo-controls__scrubber .rangeSlider__handle::after{width:11px;height:11px}.vue-canvasvideo__elapsed{color:rgba(255,255,255,0.5);font-family:"Helvetica", "Open Sans", sans-serif;white-space:nowrap}.vue-canvasvideo__wrap--inner:hover .vue-canvasvideo-controls{opacity:1}

</style>






// WEBPACK FOOTER //
// src/components/Settings/Video.vue